<template>
  
  <van-row align="center" class="page-container" id="main">
    <h2>您正在进行找回密码</h2>
    <van-col offset="1" span="22">
      <van-steps :active="CurrentStep">
        <van-step>选择方式</van-step>
        <van-step>输入信息</van-step>
        <van-step>验证身份</van-step>
        <van-step>设置新密码</van-step>
        <van-step>完成</van-step>
      </van-steps>
    </van-col>
    <van-col offset="1" span="22" id="step-content" style="margin-top: 15px;">
      <transition name="el-fade-in-linear" mode="out-in">
          <router-view></router-view>
      </transition>
    </van-col>
  </van-row>
</template>
<script>
import { Steps, Step } from 'vant'
export default {
  components: {
    [Steps.name]: Steps,
    [Step.name]: Step
  },
  name: 'Findpwd',
  data () {
    return {
      CurrentStep: 0
    }
  },
  watch: {
    '$route' (to, from) {
      switch (to.name) {
        case 'FindpwdSelectMethod':
          this.CurrentStep = 0
          break
        case 'FindpwdByPhone':
        case 'FindpwdByOrder':
          this.CurrentStep = 1
          break
        case 'FindPwdVerify':
        case 'ConfirmUsername':
          this.CurrentStep = 2
          break
        case 'FindPwdReset':
          this.CurrentStep = 3
          break
        case 'FindPwdSuccess':
          this.CurrentStep = 4
          break
        default:
          this.CurrentStep = 0
      }
      console.log(to)
    }
  },
  mounted: function () {
    const _this = this
    this.$root.$on('changeCurrentStep', (step) => {
      _this.changeCurrentStep(step)
    })
  },
  methods: {
    changeCurrentStep: function (step) {
      this.CurrentStep = step
    }
  }
}
</script>